
// const API_ROOTT = 'https://app-node-talkcmo.ondotmail.com:5030';
const API_ROOT = 'https://app-node.talkcmo.com:3019';
//
// const API_ROOT = 'http://localhost:3019';

// const webPath = 'https://talkcmo.ondotmail.com'
const webPath = 'https://talkcmo.com'
// const webPath = 'https://enterprisetalk.com'   // for img test only at local


export { API_ROOT, webPath };